import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import homework_V2Service from '../../services/homework_V2.service';
import models_V2Service from '../../services/models_V2.service';
import ComponentTable from '../ComponentTable';

function GroupHistoryHwDate() {
    const { t } = useTranslation();
    const { isEmpty } = useSelector(state => state.AsyncTable.table);
    const history = useHistory();
    const { groupId, usersId, studentId } = useParams();

    const actions = [
        {
            title: t('quiz.more'),
            onClick: (_, row) =>
                history.push({
                    pathname: `/groups/${groupId}/hwHistory/${usersId}/date/${studentId}/settings/${row.key}`,
                    state: { data: row },
                }),
            outOfMenu: true,
            Icon: OpenInNewIcon,
        },
    ];

    return (
        <>
            <Button
                onClick={() => history.push(`/groups/${groupId}/hwHistory/${usersId}`)}
                style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '5px', color: 'black' }}
            >
                <ArrowBackIosNewIcon
                    style={{
                        fontSize: '12px',
                    }}
                />
                {t('buttons.back')}
            </Button>
            <Typography component="h2" className="container-header" pb={1}>
                {t('groups.HW_dates')}
            </Typography>
            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        homework_V2Service.getGroupHistoryHwDate(false, {
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || null,
                            order: (sort && sort.order) || 'asc',
                            filter,
                            id: usersId,
                            user: studentId,
                        }),

                    getModel: () => models_V2Service.getGroupHistoryHwDate(),
                }}
                actions={actions}
                selectable={true}
                enableFilter={isEmpty ? false : true}
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="moneybox"
            />
        </>
    );
}

export default GroupHistoryHwDate;
